<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template >
  <footer v-if="this.verticalNavMenuWidth === 'default'" class="the-footer" :class="[classes, { 'has-innovation-notice': shouldShowInnovationNotice }]">
    <!-- 중소기업 혁신바우처 사업 안내 -->
    <div v-if="shouldShowInnovationNotice && innovationNoticeData" class="innovation-voucher-notice">
      <p class="innovation-text">
        본 시스템은 중소벤처기업부에서 지원하는 2025년도 중소기업 혁신바우처 사업(No. {{ innovationNoticeData.code }})으로 인한 성과물임을 밝힙니다.
      </p>
      <p class="innovation-text innovation-text-en">
        This work (Code No. {{ innovationNoticeData.code }}) was supported by Business for SMB Innovation Voucher funded Korea Small and Medium Business Administration in 2025.
      </p>
    </div>

    <div class="copyright-section flex-wrap justify-between">
      <p style="display: flex; align-items: center;">
        <span>COPYRIGHT &copy;</span>
        <span>{{ new Date().getFullYear() }} </span>
        <a href="/" target="_blank" rel="nofollow">&nbsp;Digital SHM System</a>
        <span class="hidden sm:inline-block">, All rights Reserved. T.070-7007-7979</span>
      </p>
      <span class="md:flex hidden items-center">
            <!--
              푸터 오른쪽 문구 사용하지 않음
              <span>Hand-crafted & Made with</span>
              <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
            -->
          </span>
    </div>
  </footer>
  <footer v-else class="the-footer" :class="[classes, { 'has-innovation-notice': shouldShowInnovationNotice }]">
    <!-- 중소기업 혁신바우처 사업 안내 -->
    <div v-if="shouldShowInnovationNotice && innovationNoticeData" class="innovation-voucher-notice">
      <p class="innovation-text">
        본 시스템은 중소벤처기업부에서 지원하는 2025년도 중소기업 혁신바우처 사업(No. {{ innovationNoticeData.code }})으로 인한 성과물임을 밝힙니다.
      </p>
      <p class="innovation-text innovation-text-en">
        This work (Code No. {{ innovationNoticeData.code }}) was supported by Business for SMB Innovation Voucher funded Korea Small and Medium Business Administration in 2025.
      </p>
    </div>

    <div class="copyright-section">
      <p style="display: grid; align-items: center;">
        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} <a href="/" target="_blank" rel="nofollow">&nbsp;Digital SHM System, </a></span>
        <span>All rights Reserved</span>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'the-footer',

  props: {
    classes: {
      type: String
    }
  },

  computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    memberInfo() {
      return this.$store.state.member.memberInfo;
    },
    shouldShowInnovationNotice() {
      if (!this.memberInfo) return false;
      const companyId = Number(this.memberInfo.company_id);
      return [81, 83, 84].includes(companyId);
    },
    innovationNoticeData() {
      if (!this.memberInfo) return null;
      const companyId = Number(this.memberInfo.company_id);

      const noticeMap = {
        83: {
          code: 'B20250818-26704'
        },
        84: {
          code: 'B20250818-26711'
        },
        81: {
          code: 'B20250821-26745'
        }
      };

      return noticeMap[companyId] || null;
    }
  },

  created() {
    if (!this.memberInfo) {
      this.$store.dispatch('member/LOAD_MEMBER_DETAIL');
    }
  }
}
</script>

<style scoped>
.the-footer {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* 혁신바우처 안내문이 있을 때 중앙 정렬 */
.the-footer.has-innovation-notice {
  align-items: center;
  text-align: center;
}

/* 혁신바우처 안내문이 없을 때 왼쪽 정렬 */
.the-footer:not(.has-innovation-notice) {
  align-items: flex-start;
  text-align: left;
}

.innovation-voucher-notice {
  width: 100%;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  border: 1px solid #2196f3;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.1);
}

.innovation-text {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #1565c0;
  text-align: center;
  line-height: 1.4;
}

.innovation-text-en {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
  opacity: 0.9;
}

.copyright-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

/* 모바일 대응 */
@media (max-width: 640px) {
  .innovation-voucher-notice {
    margin-bottom: 8px;
    padding: 6px 8px;
  }

  .innovation-text {
    font-size: 11px;
  }

  .innovation-text-en {
    font-size: 10px;
  }
}

/* 다크 테마 대응 */
@media (prefers-color-scheme: dark) {
  .innovation-voucher-notice {
    background: linear-gradient(135deg, #1e3a8a 0%, #581c87 100%);
    border-color: #3b82f6;
  }

  .innovation-text {
    color: #93c5fd;
  }
}
</style>
